import { render, staticRenderFns } from "./addgameMg.vue?vue&type=template&id=e9a344ac&"
import script from "./addgameMg.vue?vue&type=script&lang=js&"
export * from "./addgameMg.vue?vue&type=script&lang=js&"
import style0 from "./addgameMg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9a344ac')) {
      api.createRecord('e9a344ac', component.options)
    } else {
      api.reload('e9a344ac', component.options)
    }
    module.hot.accept("./addgameMg.vue?vue&type=template&id=e9a344ac&", function () {
      api.rerender('e9a344ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/groMore/components/addgameMg.vue"
export default component.exports